import { render, staticRenderFns } from "./UsefulVolumeArea.vue?vue&type=template&id=5045f29d&scoped=true"
import script from "./UsefulVolumeArea.vue?vue&type=script&lang=js"
export * from "./UsefulVolumeArea.vue?vue&type=script&lang=js"
import style0 from "./UsefulVolumeArea.vue?vue&type=style&index=0&id=5045f29d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5045f29d",
  null
  
)

export default component.exports